module.exports = __webpack_public_path__ + "media/images/workplace/emojis/sob-80a690788df8504042c3e0f9739011c2.png";